import { render } from "./PropertyVideo.vue?vue&type=template&id=778efa64&scoped=true"
import script from "./PropertyVideo.vue?vue&type=script&lang=js"
export * from "./PropertyVideo.vue?vue&type=script&lang=js"

import "./PropertyVideo.vue?vue&type=style&index=0&id=778efa64&scoped=true&lang=css"

import exportComponent from "/var/app/current/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-778efa64"]])

export default __exports__